import React from 'react';
import { connect } from 'react-redux';
//import _get from 'lodash.get';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import makeRequest from 'utils/makeRequest';
import { getSiteDomain } from 'utils/common';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import Loader from 'components/Loader';
import s from './CoverLayout.scss';
import Card from '../../../../../components_v2/common/CardV2';
import CardCarousel from '../../../../../components_v2/common/CardCarousel/CardCarousel';
import WithMediawireStories from '../../../../../modules/WithMediawireStories/WithMediawireStories';
import InViewObserver from '../../../../../components/InViewObserver/InViewObserver';

const featuredCardIndex = 0;

const renderLeadWithList = (
  data = {},
  isPrime,
  setListItems,
  leadListItems,
  renderCallback,
  tn,
  showSpinner,
  ga4Type,
  ga4Category,
) => {
  const listItems = data.data || data.items || [];
  const featured = listItems.filter(
    item => (item.type === 'featured' ? item : null),
  );
  const getComponent = ({ item, isInlineSmallIconCard, index }) => {
    const spotlightGA =
      item.ag && item.ag === 'spotlight' ? `sl_${index + 1}_${item.id}` : null;
    if (item.replace_with_mediawire === 'yes') {
      return (
        <WithMediawireStories
          index={index}
          isInlineSmallIconCard={isInlineSmallIconCard}
          imgWidth="100"
          isWapView={false}
          fallbackItem={item}
          setListItems={setListItems}
          listItems={leadListItems}
          renderCallback={renderCallback}
          slotId={item.mwslotid}
          tn={tn}
          ga4Type={ga4Type}
          ga4Category={ga4Category}
          gaIndex={index + 1}
        />
      );
    }
    return (
      <Card
        data={item}
        isInlineSmallIconCard={isInlineSmallIconCard}
        newga={`TopSection-Actions#TopClick-Grid1/${index + 1}${item.wu}`}
        imgWidth="100"
        viewga={spotlightGA}
        timesassistCard={item && item.tn === 'timesassist_story'}
        isFirstHPassistStory={item && item.tn === 'timesassist_story'}
        onClick={() => {
          analyticsWrapper(
            'ga',
            'send',
            'event',
            'WEB-IN-NHP1',
            'TopSection-Actions',
            `TopClick-Grid1/${index + 1}${item.wu}`,
          );
          if (item && item.tn === 'timesassist_story') {
            const bodystruct = {
              version: '04Jul2023',
              type: 'redirect',
              l_bot_shown:
                item.botname && typeof item.botname === 'string'
                  ? item.botname.toLowerCase()
                  : '',
              bot_click:
                item.botname && typeof item.botname === 'string'
                  ? item.botname.toLowerCase()
                  : '',
            };
            analyticsWrapper('grx', 'track', 'TOIAssist_WidgetClick', {
              slot_name: 'toi_hp_5thstory',
              body: JSON.stringify(bodystruct),
            });
          }
          if (ga4Type && ga4Type === 'top_stories') {
            analyticsWrapper('ga4', {
              event: 'user_click',
              type: `main_line_up`,
              label: `TopClick-Grid1_${
                // eslint-disable-next-line no-nested-ternary
                item.tn === 'video'
                  ? 'videoshow'
                  : item.tn === 'news' ? 'articleshow' : item.tn
              }`,
              sublabel: item?.ga4SubLabel ? item.ga4SubLabel : '',
              category: `story_click`,
              story_no: `${index + 1}`,
              msid: item?.id,
            });
          }
          if (ga4Type && ga4Type !== 'top_stories') {
            analyticsWrapper('ga4', {
              event: 'user_click',
              type: ga4Type,
              category: ga4Category || 'story_click',
              story_no: `${index + 1}`,
              msid: item?.id,
            });
          }
        }}
        ga4Type={ga4Type}
        ga4Category={ga4Category}
        gaIndex={index + 1}
        slikeId={item?.playerId}
      />
    );
  };
  // Need to check how to add additional data prernaMishra
  const nonPrimeStories = listItems;

  const encounteredIds = new Set();

  return (
    <div className={s.column1} key="cover_featured">
      {featured.map((item, index) => {
        const spotlightGA =
          item.ag && item.ag === 'spotlight' ? `sl_view_1_${item.id}` : null;
        if (Array.isArray(item.imagelist) && item.imagelist.length > 1) {
          return (
            <CardCarousel
              data={item}
              isLeadImageNews
              showLiveBtn
              newga={`TopSection-Actions#TopClick-Grid1/0${item.wu}`}
              shouldNotlazyloadImage
              imgWidth="600"
              key={item.id}
              viewga={spotlightGA}
              insertCaptionPlatform="web"
              ga4Type={ga4Type}
              ga4Category={ga4Category}
              gaIndex={index + 1}
            />
          );
        }
        return (
          <Card
            data={item}
            isLeadImageNews
            showLiveBtn
            newga={`TopSection-Actions#TopClick-Grid1/0${item.wu}`}
            shouldNotlazyloadImage
            imgWidth="600"
            key={item.id}
            viewga={spotlightGA}
            insertCaptionPlatform="web"
            ga4Type={ga4Type}
            ga4Category={ga4Category}
            gaIndex={index + 1}
            slikeId={item?.playerId}
          />
        );
      })}
      <div className={`${s.col2_grid} ${s.grid_loader} ${'grid_wrapper'}`}>
        {showSpinner && (
          <div className={s.loader_box}>
            <Loader />
          </div>
        )}

        {nonPrimeStories.map((item, index) => {
          if (item.type !== 'featured') {
            if (!encounteredIds.has(item.id)) {
              // Mark the ID as encountered
              encounteredIds.add(item.id);

              return (
                <div className="col_l_6" key={item.id}>
                  {getComponent({
                    item,
                    isInlineSmallIconCard: true,
                    index,
                  })}
                </div>
              );
            }
            return null;
          }
          return null;
        })}
      </div>
    </div>
  );
};

const renderColumn = (dataObj, ga4Type, ga4Category) => {
  const listItems = dataObj.data || dataObj.items || [];
  return (
    <div className={s.column2} key="cover_grid_2">
      {listItems &&
        listItems instanceof Array &&
        listItems.map((item, index) => {
          const spotlightGA =
            item.ag && item.ag === 'spotlight'
              ? `sl_${index + 1}_${item.id}`
              : null;
          return (
            <Card
              key={item.id}
              data={item}
              isVerticalTile
              newga={`TopSection-Actions#TopClick-Grid2/${index}${item.wu}`}
              imgWidth="200"
              viewga={spotlightGA}
              ga4Type={ga4Type}
              ga4Category={ga4Category}
              gaIndex={index + 1}
              newgaLabel="TopClick-Grid2"
              slikeId={item?.playerId}
            />
          );
        })}
    </div>
  );
};

const getTwoColListItem = (item, index, ga4Type, ga4Category) => (
  <Link
    key={item.id}
    to={item.wu}
    className={`linktype1 ${item.tn === 'liveblog' ? s.lbBlinker : ''}`}
    data-newga={`TopSection-Actions#TopClick-Grid3/${index}/${item.wu}`}
    target={item.target === '_blank' ? item.target : ''}
    onClick={() => {
      analyticsWrapper(
        'ga',
        'send',
        'event',
        'WEB-IN-NHP1',
        'TopSection-Actions',
        `TopClick-Grid3/${index}${item.wu}`,
      );
      if (ga4Type && ga4Type === 'top_stories') {
        analyticsWrapper('ga4', {
          event: 'user_click',
          type: `main_line_up`,
          label: `TopClick-Grid3_${
            // eslint-disable-next-line no-nested-ternary
            item.tn === 'video'
              ? 'videoshow'
              : item.tn === 'news' ? 'articleshow' : item.tn
          }`,
          category: `story_click`,
          story_no: `${index + 1}`,
          msid: item?.id,
        });
      }
      if (ga4Type && ga4Type !== 'top_stories') {
        analyticsWrapper('ga4', {
          event: 'user_click',
          type: ga4Type,
          category: ga4Category || 'story_click',
          story_no: `${index + 1}`,
          msid: item?.id,
        });
      }
      if (item && item.tn === 'timesassist_story') {
        analyticsWrapper('grx', 'track', 'TOIAssist_WidgetClick', {
          slot_name: 'toi_hp_rhs_5thstory',
          body: JSON.stringify({
            version: '04Jul2023',
            type: 'redirect',
            l_bot_shown:
              item.botname && typeof item.botname === 'string'
                ? item.botname.toLowerCase()
                : '',
            bot_click:
              item.botname && typeof item.botname === 'string'
                ? item.botname.toLowerCase()
                : '',
          }),
        });
      }
    }}
    ga4Data={
      ga4Type && [
        {
          event: 'user_click',
          type: `${ga4Type}`,
          category: `${'story_click' || ga4Category}`,
          story_no: `${index + 1}`,
          msid: item?.id,
        },
      ]
    }
  >
    {item.tn === 'liveblog' ? <div className={`${s.liveBtn} ${s.red}`} /> : ''}
    {item &&
      item.tn === 'timesassist_story' &&
      item.ctaText && (
        <label className="timesassistLabel">
          {item.ctaText}
          {item.toiPlusLogo && <i className="timesAssistPlusIcon" />}
        </label>
      )}
    <span
      {...item.ag &&
        item.ag === 'spotlight' && {
          'data-scrollga': `sl_view_${index + 1}_${item.msid}`,
        }}
    >
      {/* {typeof item.titlePrefix !== 'undefined' && (
                  <small className="toiPlusTag">{item.titlePrefix}:</small>
                )} */}
      {item.hl}
    </span>
    {item.cs === 'prime' ? <i className="icon toiplus" /> : null}
    {item.type === 'photostory' ? <i className="icon photos" /> : null}
    {item.type === 'video' ? <i className="icon videos" /> : null}
  </Link>
);

const renderTwoColumn = (
  data,
  isPrime,
  childrenComponents,
  belowStoriesInsertComponent,
  setListItems,
  renderCallback,
  leadListItems,
  tn,
  ga4Type,
  ga4Category,
) => {
  const listItems = data.data || data.items || [];
  return (
    <div className={s.column3} key="cover_grid_3">
      {childrenComponents}
      <div className={s.top_news_list}>
        {listItems &&
          listItems instanceof Array &&
          listItems.map((item, index) => (
            <React.Fragment key={item.id}>
              {item.replace_with_mediawire === 'yes' ? (
                <WithMediawireStories
                  index={index}
                  imgWidth="100"
                  isWapView={false}
                  fallbackItem={item}
                  listItems={leadListItems}
                  setListItems={setListItems}
                  renderCallback={renderCallback}
                  renderFunc={getTwoColListItem}
                  slotId={item.mwslotid}
                  tn={tn}
                  ga4Type={ga4Type}
                  ga4Category={ga4Category}
                  gaIndex={index + 1}
                />
              ) : (
                getTwoColListItem(item, index, ga4Type, ga4Category)
              )}
            </React.Fragment>
          ))}
      </div>
      {belowStoriesInsertComponent}
    </div>
  );
};

class CoverLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listItems: null,
      loading: false,
      refreshLoader: false,
      newStoryNumber: 0,
      showSpinner: false,
    };
    this.isToiAssistStoryGrxFired = false;
  }

  componentDidMount() {
    window.addEventListener('beforeunload', this.moveToTop);
    const { sectionData = {}, isUsHP } = this.props;
    if (sectionData && sectionData.id === 'topstories' && !isUsHP) {
      this.intervalID = setInterval(() => {
        const { geoCityData: { city } } = this.props;
        this.loadDataForTopStories(city, true);
      }, 3 * 60 * 1000);
      // const { geoCityData: { city } } = this.props;
      // if (city && !sectionData.isTopCity) {
      //   this.updateCityNewsInTopStories(city);
      // }
    }
  }

  moveToTop = () => {
    if (this.state.refreshLoader) {
      window.scrollTo(0, 0);
      document.body.style.overflow = 'hidden';
    }
  };

  refreshPage = () => {
    // analyticsWrapper(
    //   'gaAndGrx',
    //   'send',
    //   'event',
    //   window.categoryForGA,
    //   'Click_RefreshCTA',
    //   '',
    // );
    this.setState({ newStoryNumber: 0, refreshLoader: true }, () =>
      window.location.reload(),
    );
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'inactive_refresh',
      label: 'New Story',
    });
  };

  componentDidUpdate(prevProps) {
    const { geoCityData: { city: prevCity = '' } } = prevProps;
    const { geoCityData: { city } } = this.props;
    const { sectionData = {} } = this.props;

    if (
      sectionData &&
      sectionData.id === 'topstories' &&
      city &&
      prevCity !== city
    ) {
      // this.updateCityNewsInTopStories(city);
      // this.loadDataForTopStories(city);
    }
  }

  componentWillUnmount() {
    clearInterval(this.intervalID);
    window.removeEventListener('beforeunload', this.moveToTop);
  }

  updateCityNewsInTopStories = city => {
    if (!city) return;
    this.setState({ showSpinner: true });

    const dataUrl = `${getSiteDomain()}/toihomepagecityfeedspadata.cms?feedtype=sjson&geocl=${city}&reqfrm=web`;

    makeRequest
      .get(dataUrl, { isMobile: this.props.isMobile }, 'skipfeedengine')
      .then(data => {
        if (
          data &&
          data.data &&
          Array.isArray(data.data.items) &&
          data.data.items.length
        ) {
          const cityNews = data.data.items;
          try {
            // calling function to replace city news as per current user location
            this.updateCityNews(cityNews);
          } catch (e) {
            this.setState({ showSpinner: false });
            console.log(e);
          }
        } else {
          this.setState({ showSpinner: false });
        }
      })
      .catch(e => {
        this.setState({ showSpinner: false });
        console.log(e);
      });
  };

  updateCityNews = cityNews => {
    const { listItems = [] } = this.state;
    if (
      Array.isArray(listItems) &&
      listItems.length > 1 &&
      listItems[0] &&
      Array.isArray(listItems[0].items) &&
      listItems[0].items.length > 10 &&
      Array.isArray(cityNews) &&
      cityNews.length
    ) {
      const colOneData = listItems[0].items;
      // deduping city news if already present in top stories
      const ctNews = this.dedupeCityNews(colOneData, cityNews);
      if (ctNews.length) {
        let tmpcntr = 0;
        for (let i = 0; i < colOneData.length; i += 1) {
          const tmpdata = colOneData[i];
          if (tmpdata && tmpdata.citynews === 'y') {
            colOneData[i] = ctNews[tmpcntr] || colOneData[i];
            tmpcntr += 1;
            if (tmpcntr > ctNews.length - 1 || tmpcntr > 4) break;
          }
        }
      }
      listItems[0].items = colOneData;
      this.setState({ listItems, showSpinner: false });
    }
  };

  dedupeCityNews = (topStoryNews, cityNews) => {
    const ctNews = [];
    for (let i = 0; i < cityNews.length; i += 1) {
      let match = false;
      for (let j = 0; j < topStoryNews.length; j += 1) {
        if (cityNews[i].id === topStoryNews[j].id) {
          match = true;
          break;
        }
      }
      if (!match) ctNews.push(cityNews[i]);
    }
    return ctNews;
  };

  loadDataForTopStories = (city, refresh = false) => {
    if (!city) {
      return;
    }
    this.setState({ loading: true });

    const dataUrl = `${getSiteDomain()}/webhomepagefeedspadata.cms?feedtype=sjson&istoponly=y${
      this.props.isPrime ? '&pc1=yes' : ''
    }`;

    makeRequest.get(dataUrl, {}, 'skipfeedengine').then(data => {
      if (data && data.data && data.data.length > 0 && !refresh) {
        this.setState({
          listItems: data.data,
          loading: false,
        });
      } else if (data && data.data && data.data.length > 0 && refresh) {
        this.compareTopStories(data.data);
        this.setState({ loading: false });
      } else {
        this.setState({ loading: false });
      }
    });
  };

  compareTopStories = newStories => {
    const { listItems = [] } = this.state;
    const previousStoriesId = this.getIdList(listItems);
    const newStoriesId = this.getIdList(newStories);
    const filteredArray = newStoriesId.filter(
      id => previousStoriesId.indexOf(id) === -1,
    );
    if (filteredArray.length >= 1) {
      // if (this.state.newStoryNumber < 1) {
      //   analyticsWrapper(
      //     'gaAndGrx',
      //     'send',
      //     'event',
      //     window.categoryForGA,
      //     'View_RefreshCTA',
      //     '',
      //     {
      //       nonInteraction: 1,
      //     },
      //   );
      // }
      this.setState({
        newStoryNumber: filteredArray.length,
      });
    } else {
      this.setState({ newStoryNumber: 0 });
    }
  };

  getIdList = (stories = []) => {
    const idList = [];
    if (stories && stories.length > 0) {
      stories.forEach(storyObject => {
        // eslint-disable-next-line no-unused-expressions
        Array.isArray(storyObject.items) &&
          storyObject.items.forEach(story => {
            if (
              (story.ag === 'spotlight' && story.id) ||
              story.citynews === 'y'
            )
              return;
            idList.push(story.id);
          });
      });
    }
    return idList;
  };

  setListItems = listItems => {
    this.setState({ listItems });
  };

  render() {
    const { sectionData = {}, renderCallback } = this.props;
    const ga4Type = sectionData?.ga4Type ? sectionData?.ga4Type : '';
    const ga4Category = sectionData?.ga4Category
      ? sectionData?.ga4Category
      : '';
    const { newStoryNumber, refreshLoader, showSpinner } = this.state;
    let listItems = sectionData.data || sectionData.items || [];
    if (
      Array.isArray(this.state.listItems) &&
      this.state.listItems.length > 0
    ) {
      listItems = this.state.listItems;
    } else {
      this.setListItems(listItems);
    }

    if (
      listItems &&
      Array.isArray(listItems) &&
      !this.isToiAssistStoryGrxFired &&
      typeof window === 'object'
    ) {
      const column2ListData = listItems.filter(
        item => item.tn === 'column_2_list',
      );
      if (
        Array.isArray(column2ListData) &&
        column2ListData[0] &&
        column2ListData[0].items &&
        Array.isArray(column2ListData[0].items)
      ) {
        const column2ListTOIAssistStory = column2ListData[0].items.filter(
          item => item.tn === 'timesassist_story',
        );
        if (
          Array.isArray(column2ListTOIAssistStory) &&
          column2ListTOIAssistStory.length > 0 &&
          column2ListTOIAssistStory[0] &&
          column2ListTOIAssistStory[0].botname
        ) {
          const column2ListTOIAssistStoryItem = column2ListTOIAssistStory[0];
          setTimeout(() => {
            const bodystruct = {
              version: '04Jul2023',
              type: 'redirect',
              l_bot_shown:
                column2ListTOIAssistStoryItem &&
                column2ListTOIAssistStoryItem.botname &&
                column2ListTOIAssistStoryItem.botname.toLowerCase(),
            };
            analyticsWrapper('grx', 'track', 'TOIAssist_WidgetView', {
              slot_name: 'toi_hp_rhs_5thstory',
              body: JSON.stringify(bodystruct),
            });
          }, 5000);
          this.isToiAssistStoryGrxFired = true;
        }
      }
    }

    return (
      <>
        <div id="adsdivLyr" className="adsdivlyr" />
        <div id="tileyeDiv" />
        <div id="netspidersosh" name="netspidersosh" className="adsdivlyr" />
        <div className={`${s.flexbox} ${this.state.loading ? s.loader : ''}`}>
          {refreshLoader && <div className={s.refresh_loader} />}
          {newStoryNumber >= 1 && (
            <InViewObserver
              inViewCallback={() => {
                analyticsWrapper('ga4', {
                  event: 'user_shown',
                  type: `inactive_refresh`,
                  label: `${newStoryNumber === 1 ? 'Story' : 'Stories'}`,
                });
              }}
            >
              <button
                id="refresh-button"
                className={`${s.new_story_btn} ${
                  window.isStickyHeader ? 'sticky' : ''
                }`}
                onClick={this.refreshPage}
              >
                {`${newStoryNumber} New ${
                  newStoryNumber === 1 ? 'Story' : 'Stories'
                }`}{' '}
                <img
                  src="https://timesofindia.indiatimes.com/photo/86578216.cms"
                  alt="refresh icon"
                />
              </button>
            </InViewObserver>
          )}

          {listItems.map((item = {}) => {
            switch (item.tn) {
              case 'lead_plus_4_list': {
                const itemObj = item;
                const itemArr = item.data || item.items;
                if (
                  itemArr instanceof Array &&
                  typeof itemArr[featuredCardIndex] === 'object'
                ) {
                  itemArr[featuredCardIndex].type = 'featured';
                }
                return renderLeadWithList(
                  itemObj,
                  this.props.isPrime,
                  this.setListItems,
                  listItems,
                  renderCallback,
                  item.tn,
                  showSpinner,
                  ga4Type,
                  ga4Category,
                );
              }
              case 'column_1_list': {
                return renderColumn(item, ga4Type, ga4Category);
              }
              case 'column_2_list': {
                return renderTwoColumn(
                  item,
                  this.props.isPrime,
                  this.props.children,
                  this.props.belowStoriesInsertComponent,
                  this.setListItems,
                  renderCallback,
                  listItems,
                  item.tn,
                  ga4Type,
                  ga4Category,
                );
              }
              default: {
                return null;
              }
            }
          })}
        </div>
      </>
    );
  }
}
CoverLayout.propTypes = {
  sectionData: PropTypes.shape({}).isRequired,
  isPrime: PropTypes.bool,
  children: PropTypes.element,
  belowStoriesInsertComponent: PropTypes.element,
  geoCityData: PropTypes.shape({
    city: PropTypes.string,
  }),
  renderCallback: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
};
CoverLayout.defaultProps = {
  isPrime: false,
  children: null,
  belowStoriesInsertComponent: null,
  geoCityData: {},
  isMobile: false,
};

const mapStateToProps = state => ({
  isMobile: state.isMobile,
});

export default connect(mapStateToProps)(CoverLayout);
